import { CommunityServiceCategoryService } from 'src/app/core/service/community-service-category.service';
import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class CommunityServiceCategoryValidators
{
    constructor(private communityServiceCategoryService: CommunityServiceCategoryService) { }

    public validateCommunityServiceCategoryNameUnique(control: UntypedFormControl, initialName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialName !== control.value)
            {
                this.communityServiceCategoryService.existsCommunityServiceCategoryName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
